export default "__VITE_ASSET__DxrjM3Xz__"